import { Marquee } from "@/components/Marquee/Marquee";
import { Box } from "@/layouts/LayoutComponents";
// import { Box } from "@fastlooptech/layout-components";

export default function MarqueeWrapper(props: any) {
  const { text } = props;

  return (
    <Box className="w-screen overflow-hidden justify-center">
      <Marquee>{text}</Marquee>
    </Box>
  );
}